import VersionUpgrade from './version-upgrade-directive';

const MODULE_NAME = 'App.common.widgets.version-upgrade';
const module = angular.module(MODULE_NAME, [])
    .directive(VersionUpgrade.DIRECTIVE_NAME, VersionUpgrade);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/version-upgrade/version-upgrade-module.js